<template>
  <generic-update :model="model">
    <template v-slot:form="{ error, fetch, item, loading, submit }">
      <show-person-options-form
        :with-data="item"
        :error="error"
        :loading="loading"
        @submit="submit"
        @reset="fetch"
      ></show-person-options-form>
    </template>
  </generic-update>
</template>

<script>
// import { mapState } from "vuex"

import ShowPersonOptionsForm from "./ShowPersonOptionsForm"
import models from "@/models"

export default {
  components: { ShowPersonOptionsForm },
  data() {
    return {
      model: models.ShowPersonOptions,
      localData: {},
    }
  },
}
</script>
